import { ReschedulableBooking } from '@kouto/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface GuestRescheduleState {
  readonly cartId?: string;
  readonly token?: string;
  readonly bookings: ReschedulableBooking[];
  readonly isLoading: boolean;
  readonly selectedBookingId?: string;
  readonly selectedResourceId?: string;
  readonly selectedRescheduleDate?: string;
  readonly selectedCalendarDate?: string;
}

const initialState: GuestRescheduleState = {
  bookings: [],
  isLoading: false,
  selectedCalendarDate: undefined,
  selectedBookingId: undefined,
  selectedResourceId: undefined,
  selectedRescheduleDate: undefined,
};

export const guestRescheduleSlice = createSlice({
  name: 'guestReschedule',
  initialState,
  reducers: {
    setCartData(
      state,
      action: PayloadAction<{ cartId: string; token: string }>,
    ) {
      const newState = {
        ...state,
        cartId: action.payload.cartId,
        token: action.payload.token,
      };

      return newState;
    },
    setBookings(state, action: PayloadAction<ReschedulableBooking[]>) {
      const newState = {
        ...state,
        bookings: action.payload,
      };

      return newState;
    },
    setSelectedBookingId(state, action: PayloadAction<string>) {
      const newState = {
        ...state,
        selectedBookingId: action.payload,
      };

      return newState;
    },
    setSelectedResourceId(state, action: PayloadAction<string>) {
      const newState = {
        ...state,
        selectedResourceId: action.payload,
      };

      return newState;
    },
    setSelectedRescheduleDate(state, action: PayloadAction<string>) {
      const newState = {
        ...state,
        selectedRescheduleDate: action.payload,
      };
      return newState;
    },
    setSelectedCalendarDate(state, action: PayloadAction<string>) {
      const newState = {
        ...state,
        selectedCalendarDate: action.payload,
      };

      return newState;
    },
    setIsLoading(state, action: PayloadAction<boolean>) {
      const newState = {
        ...state,
        isLoading: action.payload,
      };

      return newState;
    },
    resetRescheduleState() {
      return initialState;
    },
  },
});

export const {
  setCartData,
  setBookings,
  setSelectedBookingId,
  setSelectedRescheduleDate,
  setSelectedCalendarDate,
  setSelectedResourceId,
  setIsLoading,
  resetRescheduleState,
} = guestRescheduleSlice.actions;

export default guestRescheduleSlice.reducer;
